<template>
  <Modal
    :width="480"
    name="HAUSEFUL_INVOICE_SHOW_MODAL"
    :title="$t('hausefulInvoices.modals.show.title')"
  >
    <template v-slot:body>
      <div v-if="hausefulInvoiceInfo">
        <v-row>
          <v-col cols="12" sm="4">
            <h6 class="text-uppercase grey--text">
              {{ $t('hausefulInvoices.modals.show.createdAt') }}
            </h6>
            <span class="body-2">
              {{ formatDate(hausefulInvoiceInfo.created_at) }}
            </span>
          </v-col>
          <v-col cols="12" sm="8">
            <h6 class="text-uppercase grey--text">
              {{ $t('hausefulInvoices.modals.show.file') }}
            </h6>
            <v-btn
              v-if="
                hausefulInvoiceInfo.file_response &&
                  hausefulInvoiceInfo.file_response.url
              "
              :href="hausefulInvoiceInfo.file_response.url"
              target="_blank"
              color="primary"
              elevation="0"
              small
            >
              <v-icon left small>
                mdi-download
              </v-icon>
              <span class="mw-200 caption text-truncate">
                {{ $t('hausefulInvoices.modals.show.download') }}
                {{ hausefulInvoiceInfo.file_response.name }}
              </span>
            </v-btn>
            <div v-else>---</div>
          </v-col>
        </v-row>

        <v-row>
          <v-col>
            <h6 class="text-uppercase grey--text">
              {{ $t('hausefulInvoices.modals.show.createdBy') }}
            </h6>
            <span
              v-if="
                hausefulInvoiceInfo.created_by &&
                  hausefulInvoiceInfo.created_by.name
              "
              class="body-2"
            >
              {{ hausefulInvoiceInfo.created_by.name }}
            </span>
            <div v-else>---</div>
          </v-col>
        </v-row>

        <v-row>
          <v-col>
            <h6 class="text-uppercase grey--text">
              {{ $t('hausefulInvoices.modals.show.client') }}
            </h6>
            <span
              v-if="
                hausefulInvoiceInfo.real_estate &&
                  hausefulInvoiceInfo.real_estate.name
              "
              class="body-2"
            >
              {{ hausefulInvoiceInfo.real_estate.name }}
            </span>
            <div v-else>---</div>
          </v-col>
        </v-row>

        <v-row>
          <v-col>
            <h6 class="text-uppercase grey--text">
              {{ $t('hausefulInvoices.modals.show.branch') }}
            </h6>
            <span
              v-if="
                hausefulInvoiceInfo.branch &&
                  hausefulInvoiceInfo.branch.name
              "
              class="body-2"
            >
              {{ hausefulInvoiceInfo.branch.name }}
            </span>
            <div v-else>---</div>
          </v-col>
        </v-row>

        <v-divider class="my-5" />

        <v-row>
          <v-col>
            <h6 class="text-uppercase grey--text">
              {{ $t('hausefulInvoices.modals.show.paymentList') }}
            </h6>
            <v-data-table
              :headers="headers"
              :items="hausefulInvoiceInfo.payment_list"
              mobile-breakpoint="20"
              hide-default-footer
              disable-pagination
              disable-filtering
              dense
            >
              <template v-slot:[`item.created_at`]="{ item }">
                <span class="caption">
                  {{ formatDateNoTime(item.created_at) }}
                </span>
              </template>
              <template v-slot:[`item.host.name`]="{ item }">
                <span class="d-block mw-100 caption text-truncate">
                  {{ item.host.name }}
                </span>
              </template>
              <template v-slot:[`item.realty_quantity`]="{ item }">
                <span class="caption">
                  {{ item.realty_quantity }}
                </span>
              </template>
              <template v-slot:[`item.total`]="{ item }">
                <span class="d-block mw-100 caption text-truncate">
                  {{ formatMoney(item.total) }}
                </span>
              </template>
            </v-data-table>
          </v-col>
        </v-row>
      </div>
    </template>
  </Modal>
</template>

<script>
import { mapGetters, mapMutations } from 'vuex'
import {
  catalogDate,
  catalogDateWithoutTime,
  catalogMonetary,
} from '@/util/catalog'
import { hausefulTakeRateInvoicesSummary } from '../hausefulTakeRateInvoicesTableHeader'

import Modal from '@/components/app/Modal'

export default {
  name: 'ModalHausefulTakeRateInvoiceShow',

  components: {
    Modal,
  },

  data() {
    return {
      formatDate: catalogDate,
      formatDateNoTime: catalogDateWithoutTime,
      formatMoney: catalogMonetary,
      headers: hausefulTakeRateInvoicesSummary,
    }
  },

  computed: {
    ...mapGetters(['isLoading', 'hausefulInvoiceInfo']),
  },

  methods: {
    ...mapMutations(['closeAllModals']),
  },
}
</script>
